import './style.scss';

window.addEventListener('blur', () => {
    const active = document.activeElement;
    if (active && active.tagName === 'IFRAME') {
        const popup = active.closest('.map-container')?.querySelector('.map-popup');
        if (popup) popup.style.opacity = '0';
    }
}, true);
